<template>
  <div class="fulfillment-timer-container">
    <span class="fulfillment-timer">{{ timerFormat }}</span>
    <svg
      height="46"
      width="46"
      :style="{
        strokeDasharray: '132px',
        strokeDashoffset: `${getTimeProgress}px`,
        transform: 'rotate(-90deg)'
      }"
    >
      <circle cx="23" cy="23" r="21" :stroke="color.stroke" stroke-width="4" :fill="color.fill" />
      {{ time }}
    </svg>
  </div>
</template>
<script>
export default {
  name: "timer",
  data() {
    return {
      time: this.max,
      color: {
        fill: "#00A29B",
        stroke: "#00C19F"
      },
      accumulatedTime: 0 // accumulated time
    };
  },
  props: {
    max: {
      type: Number,
      required: true
    },
    stopped: {
      type: Boolean,
      default: false
    }
  },
  mounted() {
    this.timeout = setInterval(() => {
      this.accumulatedTime += 1000;
      if (!this.stopped) {
        this.time = this.time - 1;
      }
    }, 1000);
  },
  watch: {
    time() {
      this.getColor((this.time * 100) / this.max);
      if (this.time === 0) {
        clearInterval(this.timeout);
        this.$emit("finish");
      }
    }
  },
  methods: {
    getColor(percent) {
      const colors = [
        {
          fill: "#B30000", // red
          stroke: "#EE3823"
        },
        {
          fill: "#FF7000", // orange
          stroke: "#FF9231"
        },
        {
          fill: "#00A29B", // green
          stroke: "#00C19F"
        }
      ];
      // fix error on console, when is 100% the result is position 3 and it's not exist
      this.color = colors[Math.floor(percent / 33)] || colors[2];
    }
  },
  computed: {
    getTimeProgress() {
      const percentLeft = (this.time * 100) / this.max;
      const offset = ((100 - percentLeft) * 132) / 100;
      return offset;
    },
    timerFormat() {
      const timeMinute = Math.floor(this.time / 60);
      const minutes = timeMinute > 0 ? `${timeMinute}:` : "";
      const seconds = (this.time % 60)
        .toFixed(0)
        .toString()
        .padStart(2, "0");
      return `${minutes}${seconds}`;
    }
  }
};
</script>

<style scoped>
.fulfillment-timer-container {
  position: relative;
  width: 45px;
  height: 45px;
  box-sizing: border-box;
  display: table;
  margin: auto;
}

.fulfillment-timer {
  margin: auto;
  display: table;
  color: white;
  font-weight: bold;
  text-align: center;
  box-sizing: border-box;
  position: absolute;
  width: 100%;
  left: 0px;
  font-size: 12px;
  top: -moz-calc(50% - 10px);
  top: -webkit-calc(50% - 10px);
  top: -o-calc(50% - 10px);
  top: calc(50% - 10px);
  z-index: 1;
}
</style>
